angular.module('tasks')
    .controller('TaskDialogController', function ($timeout, $scope, $rootScope, $filter, $uibModalInstance, data, toastr, Task, Priority, TaskStatus, User, Principal, ReminderTime, TaskService, UserGroup) {
        $scope.item = data
        $scope.activeTab = 3

        $scope.refreshNotActiveUsers = () => {
            if ($scope.item.workers) {
                $scope.notActiveWorkers = $scope.item.workers.filter(u => u.activated === false)
            }
        }
        $scope.refreshNotActiveUsers()

        $scope.startTimeOpts = {
            altInput: true,
            altFormat: "Y-m-d H:i",
            dateFormat: "Z",
            placeholder: 'Ustaw datę...',
            enableTime: true,
            time_24hr: true,
            wrap: true,
            allowInput: true,
            defaultDate: $scope.item.startTime,
            onChange: function (selectedDates, dateStr, instance) {
            }
        };

        $scope.endTimeOpts = {
            altInput: true,
            altFormat: "Y-m-d H:i",
            dateFormat: "Z",
            placeholder: 'Ustaw datę...',
            enableTime: true,
            time_24hr: true,
            // allowInput: true,
            defaultDate: $scope.item.endTime,
            onChange: function (selectedDates, dateStr, instance) {
            }
        };

        if (!data.id && !data.moderator) {
            Principal.currentUser().then(user => $scope.item.moderator = user);
        }

        $scope.refreshUsers = q => {
            User.autocomplete({q: q}).$promise.then(items => $scope.users = items);
        };
        TaskStatus.list().$promise.then(items => $scope.statuses = items);
        ReminderTime.list().$promise.then(items => $scope.reminderTimes = items);

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.collisionCheck = () => {
            let params = {
                id: $scope.item.id,
                workers: $scope.item.workers,
                startTime: $scope.item.startTime ? moment($scope.item.startTime) : null,
                endTime: $scope.item.endTime ? moment($scope.item.endTime) : null
            }
            Task.taskSlotCheck(params).$promise.then(slotCollisions => $scope.taskCollisions = slotCollisions);
        }

        $scope.removeNotActiveUser = userId => {
            $scope.item.workers = $scope.item.workers.filter(u => u.id !== userId)
            $scope.item.reminders = $scope.item.reminders.filter(i => i.user.id !== userId)
        }

        $scope.saveAndOpenTask = () => $scope.saveAndOpenFlag = true
        $scope.save = () => {
            let item = angular.copy($scope.item);
            if ($scope.item.id !== null) {
                return TaskService.updateWithTimeSlotCheck(item).then(result => $uibModalInstance.close(result));
            } else {
                return TaskService.saveWithTimeSlotCheck(item)
                    .then(result => {
                        if($scope.saveAndOpenFlag) {
                            delete $scope.saveAndOpenFlag;
                            $uibModalInstance.close(result);
                            return TaskService.showModal(result.id);
                        }
                        else
                            return $uibModalInstance.close(result);
                    })
            }
        };

        $scope.moderatorMe = () => {
            Principal.currentUser().then(user => $scope.item.moderator = user)
        };

        $scope.setEndTime = hours => {
            $scope.item.endTime = moment($scope.item.startTime).add(hours, 'h');
            $scope.collisionCheck();
        };
        $scope.$watch("item.status", (newVal, oldVal) => {
            if (oldVal !== newVal) {
                $scope.customRealEndTime = false;
                delete $scope.item.realEndTime;
            }
        });
        $scope.$watch("customRealEndTime", (newVal, oldVal) => {
            if (oldVal !== newVal) {
                if (newVal === false) {
                    delete $scope.item.realEndTime;
                }
            }
        });
        $scope.$watch("item.supervised", (newVal, oldVal) => {
            if (oldVal !== newVal && newVal === true) {
                $scope.item.sendNotifications = true;
            }
        });
        $scope.$watchCollection(() => $scope.item.workers, (newValue, oldValue) => {
            if (oldValue !== newValue) {
                $scope.collisionCheck()
                $scope.refreshNotActiveUsers()
            }
        });
    })
